// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-2YS1z","title":"jgp-3CLbt","icon":"jgp-lKyMO","closeButton":"jgp-2wbiP","scrollBody":"jgp-RpNZD"};